<div class="group-wrapper">
  <app-path-tile
    *ngFor="let tile of tiles" [tile]="tile"
    (clicked)="tileClicked.emit(tile)"
    class="tile"
  ></app-path-tile>
</div>
